import { render, staticRenderFns } from "./MobileDealBannerHeader.vue?vue&type=template&id=efeb3eb4&"
import script from "./MobileDealBannerHeader.vue?vue&type=script&lang=js&"
export * from "./MobileDealBannerHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealBannerContent: require('/app/appsumo/nuxt/components/pdp/DealBannerContent.vue').default})
